import { getServerApi } from '@/config/deployment'
import { performRequest_GET, performRequest_PUT, performRequest_POST } from '@/platform/utils/http/httpService'
import { getCurrentUserToken } from '@/platform/auth/services/authService'

let envUri = getServerApi()
let contractsUrl = envUri + '/api/contracts'

export const signAccomodationAgreement=async ({dealId, signerType, signerAccountId, signerUid, legalParams })=>{
  try{
    var token = await getCurrentUserToken()
    var headers = { "Authorization": token };
    var data = { dealId, signerType, signerAccountId, signerUid, legalParams };
    var resp = await performRequest_POST(contractsUrl+'/accomodation/sign', data, headers)
    if(resp.success) return true
    else return false
  }catch(err){
    return false
  }
}

export const getDealSignatures = ({dealId, dealSnapshotId}) => {
  return new Promise((resolve, reject) => {
    getCurrentUserToken()
      .then(token => {
        var headers = { "Authorization": token };
        var params = {
            dealId: dealId,
            dealSnapshotId:  dealSnapshotId
        }
        return performRequest_GET(contractsUrl+"/signatures", params, headers)
      })
      .then(resp => {
        if (resp.success) resolve(resp.response.data.body)
        else resolve()
      })
      .catch(err => {
        console.log("getDealSignatures | err:", err)
        reject(err)
      })
  })
}

export const upsertDealSignatures = ({dealId, dealSnapshotId, accountId, lessee, lessor}) => {
    return new Promise((resolve, reject) => {
      getCurrentUserToken()
        .then(token => {
          var headers = { "Authorization": token };
          var data = {
            dealId: dealId,
            dealSnapshotId:  dealSnapshotId,
            accountId: accountId,
            lessee: lessee,
            lessor: lessor
          }
          return performRequest_PUT(contractsUrl+"/signatures", data, headers)
        })
        .then(resp => {
          if (resp.success) resolve(resp.response.data.body)
          else reject(resp.error)
        })
        .catch(err => {
          console.log("getDealSignatures | err:", err)
          reject(err)
        })
    })
  }




// WEBPACK FOOTER //
// ./src/platform/contracts/services/contractService.js